import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './SaleHeader.scss';

interface SaleHeaderProps {}

const SaleHeader: React.FunctionComponent<SaleHeaderProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={s.strip} data-hook="saleHeader-strip">
      <div className={s.root} data-hook="saleHeader">
        <img
          alt="Arrow_edited.png"
          src="https://static.wixstatic.com/media/034a43_87eebf6073a141b4a928fd726091af0b~mv2.png/v1/fill/w_212,h_106,al_c,lg_1,q_85/Arrow_edited.webp"
          className={s.arrow}
        />
        <div className={s.textArea}>
          <div className={s.title} data-hook="saleHeader-title">
            {t('sale.header.title')}
          </div>
          <div className={s.subTitle} data-hook="saleHeader-subTitle">
            {t('sale.header.subTitle')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleHeader;
